import { FigmaFileStructureNode, FigmaNodeStructureStateV2, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOFigmaNodeStructure = z.object({
    id: z.string(),
    sourceId: z.string(),
    importState: FigmaNodeStructureStateV2,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DTOFigmaNodeStructureDetail = DTOFigmaNodeStructure.extend({
    rootNode: FigmaFileStructureNode,
});
export const DTOFigmaNodeStructureListResponse = z.object({
    structures: DTOFigmaNodeStructure.array(),
});
export const DTOFigmaNodeStructureDetailResponse = z.object({
    structure: DTOFigmaNodeStructureDetail,
});
